import { RootState } from '../../../Store/index';

export const selectUser = (state: RootState) => state;
export const selectTenants = (state: RootState) => state.TenantReducer.tenantList;
export const selectCurrentTenant = (state: RootState) => state.TenantReducer.currentTenant;
export const selectIsModalOpen = (state: RootState) => state.TenantReducer.isModalOpen;
export const selectIsSelectiveUpgradeModalOpen = (state: RootState) => {
  return state.TenantReducer.isSelectiveUpgradeModalOpen;
};